export type RgbColor = { r: number; g: number; b: number };

export const colorToRgb = (color: string): RgbColor => {
  const resultHex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
  const resultRgb = /^rgb\((\d{1,3})[, ]+(\d{1,3})[, ]+(\d{1,3})\)$/i.exec(
    color,
  );

  if (resultHex) {
    return {
      r: parseInt(resultHex[1], 16),
      g: parseInt(resultHex[2], 16),
      b: parseInt(resultHex[3], 16),
    };
  } else if (resultRgb) {
    return {
      r: parseInt(resultRgb[1], 10),
      g: parseInt(resultRgb[2], 10),
      b: parseInt(resultRgb[3], 10),
    };
  } else {
    return {
      r: 0,
      g: 0,
      b: 0,
    };
  }
}

export const extractColorFromElement = (element: HTMLElement) => {
  return window.getComputedStyle(element).color;
}